// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-video-wrapper[data-v-c6879aac] {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 100px;
  min-height: 100px;
  border-radius: 10px;
  overflow: hidden;
  flex-direction: column;
  margin: 0px;
  padding-bottom: 0.5em;
}
.chat-video-wrapper .forward[data-v-c6879aac] {
  font-size: .9em;
  display: flex;
  flex-direction: column;
  color: var(--fwd-message-color);
  margin-bottom: 0.33em;
}
.chat-video-wrapper .forward.title[data-v-c6879aac] {
  display: flex;
  flex-direction: row;
  height: 1em;
  margin-bottom: 0.4em;
}
.chat-video-wrapper .forward.title i[data-v-c6879aac] {
  margin-top: 0.4em;
  margin-right: 0.2em;
}
.chat-video-wrapper .chat-video-message[data-v-c6879aac] {
  position: relative;
  cursor: pointer;
}
.chat-video-wrapper .chat-video-message .blur-block[data-v-c6879aac] {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  z-index: 1;
}
.chat-video-wrapper .chat-video-message .blur-block img[data-v-c6879aac] {
  object-fit: cover;
  height: 100%;
  width: 100%;
  filter: blur(4px);
  -webkit-filter: blur(4px);
}
.chat-video-wrapper .chat-video-message .preview-block[data-v-c6879aac] {
  display: flex;
  width: var(--preview-block-max-width);
  height: var(--preview-block-max-height);
}
.chat-video-wrapper .chat-video-message .preview-block .message-btn-wrapper[data-v-c6879aac] {
  border-radius: 10px;
}
.chat-video-wrapper .chat-video-message .img-wrapper[data-v-c6879aac] {
  display: flex;
  overflow: hidden;
  height: 100%;
  margin: auto;
  flex-direction: column;
  border-radius: 10px;
  z-index: 9;
}
.chat-video-wrapper .chat-video-message .img-wrapper img[data-v-c6879aac] {
  width: var(--image-width);
  height: var(--image-height);
  max-width: var(--image-max-width);
  max-height: var(--image-max-height);
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatVideoMessage.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;EACjC,mCAAmC;EACnC,iBAAiB;AACnB","sourcesContent":[".chat-video-wrapper[data-v-c6879aac] {\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-width: 100px;\n  min-height: 100px;\n  border-radius: 10px;\n  overflow: hidden;\n  flex-direction: column;\n  margin: 0px;\n  padding-bottom: 0.5em;\n}\n.chat-video-wrapper .forward[data-v-c6879aac] {\n  font-size: .9em;\n  display: flex;\n  flex-direction: column;\n  color: var(--fwd-message-color);\n  margin-bottom: 0.33em;\n}\n.chat-video-wrapper .forward.title[data-v-c6879aac] {\n  display: flex;\n  flex-direction: row;\n  height: 1em;\n  margin-bottom: 0.4em;\n}\n.chat-video-wrapper .forward.title i[data-v-c6879aac] {\n  margin-top: 0.4em;\n  margin-right: 0.2em;\n}\n.chat-video-wrapper .chat-video-message[data-v-c6879aac] {\n  position: relative;\n  cursor: pointer;\n}\n.chat-video-wrapper .chat-video-message .blur-block[data-v-c6879aac] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  overflow: hidden;\n  z-index: 1;\n}\n.chat-video-wrapper .chat-video-message .blur-block img[data-v-c6879aac] {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  filter: blur(4px);\n  -webkit-filter: blur(4px);\n}\n.chat-video-wrapper .chat-video-message .preview-block[data-v-c6879aac] {\n  display: flex;\n  width: var(--preview-block-max-width);\n  height: var(--preview-block-max-height);\n}\n.chat-video-wrapper .chat-video-message .preview-block .message-btn-wrapper[data-v-c6879aac] {\n  border-radius: 10px;\n}\n.chat-video-wrapper .chat-video-message .img-wrapper[data-v-c6879aac] {\n  display: flex;\n  overflow: hidden;\n  height: 100%;\n  margin: auto;\n  flex-direction: column;\n  border-radius: 10px;\n  z-index: 9;\n}\n.chat-video-wrapper .chat-video-message .img-wrapper img[data-v-c6879aac] {\n  width: var(--image-width);\n  height: var(--image-height);\n  max-width: var(--image-max-width);\n  max-height: var(--image-max-height);\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
